var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{staticClass:"m-0 text-center border-1 rounded",attrs:{"show":"","variant":"info"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.bannerMessage)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }